<template>
  <section class="pd4">
    <div class="w1260 HomePro">
      <div class="HomeTit fadeInUp">
        <h1 class="cn">{{ $t('pages.home.advantageousTech') }}</h1>
        <p class="en OswaldMedium">Advantageous technology</p>
      </div>

      <!-- Tab navigation slider -->
      <swiper
        :modules="modules"
        :slides-per-view="4"
        :space-between="10"
        :breakpoints="{
          0: { slidesPerView: 1 },
          480: { slidesPerView: 2 },
          640: { slidesPerView: 3 },
          1024: { slidesPerView: 4 }
        }"
        class="TotalNav fadeInUp animated"
      >
        <swiper-slide
          v-for="(tab, i) in tabs"
          :key="i"
          class="item ico-bounce"
          :class="{ cur: activeTab === i }"
          @click="activeTab = i"
        >
          <div class="icon"><img class="centericon" :src="tab.icon"></div>
          <div class="tit">{{ tab.title }}</div>
          <ul class="card-nav">
            <li :class="{ on: activeTab === i }">{{ tab.subtitle }}</li>
          </ul>
        </swiper-slide>
      </swiper>

      <!-- Tab 0 -->
      <div class="slidebox" :class="{ nones: activeTab !== 0 }">
        <ul class="TabPro">
          <li class="item table">
            <div class="imgbox cell Scale-img"><a href="#"><img src="static/picture/jiaoshu.png"></a></div>
            <div class="Info cell">
              <a href='/Technical2'>
                <div class="ti">Nanocarriers based Amphiphilic molecular</div>
                <div class="p">
                  <p>
                    <b class="f_404040">{{ $t('pages.tech.micelleLiposomeTitle') }}</b><span style="color: rgb(102, 102, 102);">{{ $t('pages.tech.tab0Desc') }}</span>
                  </p>
                </div>
                <div class="txt">
                  <p><span style="font-size: 14px;">{{ $t('pages.tech.tab0Point1') }}<br></span></p>
                  <p><span style="font-size: 14px;">{{ $t('pages.tech.tab0Point2') }}</span><br></p>
                  <p><span style="font-size: 14px;">{{ $t('pages.tech.tab0Point3') }}</span></p>
                  <p><span style="font-size: 14px;">{{ $t('pages.tech.tab0Point4') }}</span></p>
                </div>
              </a>
              <a href='/Technical2' class="bluebtn">{{ $t('pages.home.learnMore') }}</a>
            </div>
          </li>
        </ul>
      </div>

      <!-- Tab 1 -->
      <div class="slidebox" :class="{ nones: activeTab !== 1 }">
        <ul class="TabPro">
          <li class="item table">
            <div class="imgbox cell Scale-img"><a href="#"><img src="static/picture/fangshengmo.png"></a></div>
            <div class="Info cell">
              <a href='/Technical1'>
                <div class="ti">Nanoparticle biointerfacing by membrane cloaking</div>
                <div class="p">
                  <p style="text-align: justify;">
                    <b class="f_404040">{{ $t('pages.tech.biomembrane') }}</b>{{ $t('pages.tech.tab1Desc') }}
                  </p>
                </div>
                <div class="txt">
                  <p>{{ $t('pages.tech.tab1Point1') }}<br></p>
                  <p>{{ $t('pages.tech.tab1Point2') }}</p>
                  <p>{{ $t('pages.tech.tab1Point3') }}</p>
                  <p>{{ $t('pages.tech.tab1Point4') }}</p>
                </div>
              </a>
              <a href='/Technical1' class="bluebtn">{{ $t('pages.home.learnMore') }}</a>
            </div>
          </li>
        </ul>
      </div>

      <!-- Tab 2 -->
      <div class="slidebox" :class="{ nones: activeTab !== 2 }">
        <ul class="TabPro">
          <li class="item table">
            <div class="imgbox cell Scale-img"><a href="#"><img src="static/picture/oulianwu.png"></a></div>
            <div class="Info cell">
              <a href='/Technical3'>
                <div class="ti">Bioconjugates</div>
                <div class="p">
                  <p><strong>{{ $t('pages.tech.bioconjugateTitle') }}</strong>{{ $t('pages.tech.tab2Desc') }}<br></p>
                </div>
                <div class="txt">
                  <p><span style="font-size: 14px;">{{ $t('pages.tech.tab2Point1') }}</span></p>
                  <p><span style="font-size: 14px;">{{ $t('pages.tech.tab2Point2') }}</span></p>
                  <p><span style="font-size: 14px;">{{ $t('pages.tech.tab2Point3') }}</span></p>
                </div>
              </a>
              <a href='/Technical3' class="bluebtn">{{ $t('pages.home.learnMore') }}</a>
            </div>
          </li>
        </ul>
      </div>

      <!-- Tab 3 -->
      <div class="slidebox" :class="{ nones: activeTab !== 3 }">
        <ul class="TabPro">
          <li class="item table">
            <div class="imgbox cell Scale-img"><a href="#"><img src="static/picture/quantum-dot-f01-m.jpg"></a></div>
            <div class="Info cell">
              <a href='/Technical4'>
                <div class="ti">Quantum dots</div>
                <div class="p">
                  <strong>{{ $t('pages.tech.quantumDotTitle') }}</strong>{{ $t('pages.tech.tab3Desc') }}
                </div>
                <div class="txt">
                  <p>{{ $t('pages.tech.tab3Point1') }}</p>
                  <p>{{ $t('pages.tech.tab3Point2') }}</p>
                  <p>{{ $t('pages.tech.tab3Point3') }}</p>
                  <p>{{ $t('pages.tech.tab3Point4') }}</p>
                </div>
              </a>
              <a href='/Technical4' class="bluebtn">{{ $t('pages.home.learnMore') }}</a>
            </div>
          </li>
        </ul>
      </div>

    </div>
  </section>
</template>

<script>
import { ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Grid } from 'swiper/modules';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import 'swiper/css';

export default {
  name: 'pd4Home',
  components: { Swiper, SwiperSlide },
  setup() {
    const activeTab = ref(0);
    const modules = [Grid];
    const { t } = useI18n();

    const tabs = computed(() => [
      {
        icon: 'static/picture/a-003-bloodtest.png',
        title: t('pages.tech.tab0Title'),
        subtitle: 'Nanocarriers based Amphiphilic molecular-Liposome, Micelle and Lipid nanoparticle'
      },
      {
        icon: 'static/picture/icon-test.png',
        title: t('pages.tech.tab1Title'),
        subtitle: 'Nanoparticle biointerfacing by membrane cloaking RBC, Platelet and Tumor cell'
      },
      {
        icon: 'static/picture/measuring-cup2.png',
        title: t('pages.tech.tab2Title'),
        subtitle: 'Bioconjugates From a specialized past to a diverse future'
      },
      {
        icon: 'static/picture/research.png',
        title: t('pages.tech.tab3Title'),
        subtitle: "Quantum dots the tiny 'rainbow' crystals behind chemistry Nobel"
      }
    ]);

    return { activeTab, modules, tabs };
  }
};
</script>

<style scoped>
.centericon {
  display: inline-block;
  width: 42px;
  height: 40px;
}
</style>
